import React from 'react'

// SubComponents
import { ModalEdit } from '../modal/edit'
import { ModalCreate } from '../modal/create'

export const CoursesModal = ({ data }) => {
  return data ? <ModalEdit data={data} /> : <ModalCreate />
}
